import React, { Component } from 'react';
import LogoHeader from '../components/logo-header-view';

export class LogoHeaderContainer extends Component {
  render() {
    return (
      <LogoHeader />
    );
  }
}

export default LogoHeaderContainer;
